module.exports = __webpack_public_path__ + "assets/01f0b73c38b42c0bafc4bdf5c894a06b.svg";